import ReactDropdown from 'rc-dropdown'
import EarnOverlay from "../earn-overlay"
import { useState } from 'react'

export const EarnButton = () => {
    const [visible, setVisible] = useState(false)
    return (
        <ReactDropdown
            visible={visible}
            overlay={<EarnOverlay setIsVisible={setVisible}/>}
            trigger={['click']}
        >
            <button
                onClick={() => setVisible(true)}
                className="font-mediumttf text-[22px] text-white"
            >
                Пополнить баланс
            </button>
        </ReactDropdown >
    )
}